<h2 class="text-black">{{ plService.produktType()?.navn }}</h2>
@if (plService.produktType()?.type === 'rap') {
<app-produktliste-result-rap />
} @else { @if (plService.beregnetPris()! > 0){
<table>
  <tbody>
    @if(plService.opkraevningsfrekvens() === 'Maanedlig'){
    <tr>
      <td style="width: 150px">Pris pr. måned</td>
      <td class="text-right">
        {{ (plService.beregnetPris() || 0) / 12 | number : "1.2" }} kr.
      </td>
    </tr>
    }
    <tr>
      <td style="width: 150px">Pris pr. år</td>
      <td class="text-right">
        {{ plService.beregnetPris() || 0 | number : "1.2" }} kr.
      </td>
    </tr>
  </tbody>
</table>
} }
